import http from "../plugins/http"

export const fetchEndpoints = async ({ query = "" }: { query?: string } = {}) => {
  const data = await http.get(`/v1/module-parameters/endpoints${query}`)
  return data
}
